import { useState, useEffect } from "react";
import { useLanguage } from "../i18n/LanguageContext";

export default function CookieConsent() {
  const [visible, setVisible] = useState(false);
  const [showCustomize, setShowCustomize] = useState(false);
  const [analytics, setAnalytics] = useState(false);
  const { t } = useLanguage();
  const c = t.cookie;

  useEffect(() => {
    const consent = localStorage.getItem("cookie_consent");
    if (!consent) {
      const timer = setTimeout(() => setVisible(true), 1500);
      return () => clearTimeout(timer);
    }
  }, []);

  const handleAcceptAll = () => {
    localStorage.setItem("cookie_consent", JSON.stringify({ essential: true, analytics: true }));
    setVisible(false);
  };

  const handleDecline = () => {
    localStorage.setItem("cookie_consent", JSON.stringify({ essential: true, analytics: false }));
    setVisible(false);
  };

  const handleSavePrefs = () => {
    localStorage.setItem("cookie_consent", JSON.stringify({ essential: true, analytics }));
    setVisible(false);
  };

  if (!visible) return null;

  return (
    <div data-testid="cookie-banner" className="fixed bottom-0 left-0 right-0 z-50 p-4 md:p-6"
      style={{ animation: "slideUp 0.5s ease-out" }}>
      <div className="max-w-4xl mx-auto bg-[#162A45] border border-slate-800 shadow-2xl shadow-black/40 p-5 md:p-6">
        <div className="flex flex-col sm:flex-row items-start sm:items-center gap-4">
          <p className="flex-1 text-slate-300 text-sm leading-relaxed">{c.message}</p>
          <div className="flex items-center gap-3 flex-shrink-0">
            <button data-testid="cookie-customize" onClick={() => setShowCustomize(!showCustomize)}
              className="text-slate-500 hover:text-white text-xs uppercase tracking-widest px-4 py-2.5 border border-slate-700 hover:border-slate-600 transition-colors duration-300">
              {c.customize}
            </button>
            <button data-testid="cookie-decline" onClick={handleDecline}
              className="text-slate-500 hover:text-white text-xs uppercase tracking-widest px-4 py-2.5 border border-slate-700 hover:border-slate-600 transition-colors duration-300">
              {c.decline}
            </button>
            <button data-testid="cookie-accept" onClick={handleAcceptAll}
              className="btn-gold bg-[#D4AF37] text-[#0B1221] text-xs font-bold uppercase tracking-widest px-6 py-2.5 hover:bg-[#F59E0B]">
              {c.accept}
            </button>
          </div>
        </div>

        {showCustomize && (
          <div className="mt-4 pt-4 border-t border-slate-800 space-y-3" data-testid="cookie-customize-panel">
            <div className="flex items-center justify-between">
              <div>
                <span className="text-white text-xs font-semibold uppercase tracking-wider">{c.essentialLabel}</span>
                <p className="text-slate-500 text-xs mt-0.5">{c.essentialDesc}</p>
              </div>
              <div className="w-10 h-5 bg-[#D4AF37] rounded-full flex items-center justify-end px-0.5 opacity-60 cursor-not-allowed">
                <div className="w-4 h-4 bg-white rounded-full" />
              </div>
            </div>
            <div className="flex items-center justify-between">
              <div>
                <span className="text-white text-xs font-semibold uppercase tracking-wider">{c.analyticsLabel}</span>
                <p className="text-slate-500 text-xs mt-0.5">{c.analyticsDesc}</p>
              </div>
              <button
                data-testid="cookie-analytics-toggle"
                onClick={() => setAnalytics(!analytics)}
                className={`w-10 h-5 rounded-full flex items-center px-0.5 transition-colors duration-200 ${analytics ? "bg-[#D4AF37] justify-end" : "bg-slate-700 justify-start"}`}
              >
                <div className="w-4 h-4 bg-white rounded-full" />
              </button>
            </div>
            <button data-testid="cookie-save-prefs" onClick={handleSavePrefs}
              className="btn-gold bg-[#D4AF37] text-[#0B1221] text-xs font-bold uppercase tracking-widest px-6 py-2 hover:bg-[#F59E0B] mt-2">
              {c.savePrefs}
            </button>
          </div>
        )}
      </div>
      <style>{`@keyframes slideUp { from { transform: translateY(100%); opacity: 0; } to { transform: translateY(0); opacity: 1; } }`}</style>
    </div>
  );
}
